module.exports = __webpack_public_path__ + "static/media/alpha_8.08efef24.png";